import { i18n } from '@/i18n'
import parent from '@/store/interfaces/tableViewGeneric'

const getTranslateMasterFilters = function () {
  return {
    id: { label: i18n.t('app.id'), value: '' },
    name: { label: i18n.t('app.name'), value: '' },
    prioridad: { label: i18n.t('configurations.prioridad'), value: '' },
    enUso: { label: i18n.t('app.in_use'), value: '' },
    activo: { label: i18n.t('app.active'), value: '' },
    DetenerEjecucion: { label: i18n.t('rules.detener_ejecucion'), value: '' },
    EnEmision: { label: i18n.t('configurations.en_emision'), value: '' },
    EnviarAutomaticamente: { label: i18n.t('configurations.envia_auto'), value: '' },
    nombreGrupo: { label: i18n.t('groups.entity_name'), value: '' },
    nombreGrupoPropietario: { label: i18n.t('groups.group_owner'), value: '' },
    distribuidor: { label: i18n.t('distributors.entity_name'), value: '' },
    empresa: { label: i18n.t('clients.entity_name'), value: '' },
  } 
}
const getColumns = function getColumns () {
  return [
    { field: 'idRegla', width: '100px', title: i18n.t('app.id'), hidden: true, columnMenu: 'myTemplate', locked: false },
    {
      field: 'Distribuidor',
      title: i18n.t('distributors.entity_name'),
      columnMenu: 'myTemplate',
      hidden: true,
      locked: false,
      width: '180px',
      only: {
        roles: [3],
      },
    },
    {
      field: 'Cliente',
      width: '250px',
      title: i18n.t('clients.entity_name'),
      columnMenu: 'myTemplate',
      locked: false,
      hidden: true,
      only: {
        roles: [7, 8, 3],
      }, 
    },
    { field: 'Nombre', width: '440px', title: i18n.t('app.name'), columnMenu: 'myTemplate', locked: false },
    { field: 'Prioridad', width: '200px', title: i18n.t('configurations.prioridad'), columnMenu: 'myTemplate', locked: false },
    {
      field: 'Activa',
      width: '200px',
      title: i18n.t('app.active'),
      columnMenu: 'myTemplate',
      locked: false,
      cell: 'checkboxTemplate',
      extraparams: { groupHeaderTemplate: ({ value, aggregates }) => value ? i18n.t('app.active') : i18n.t('app.not_active') } 
    },
    { field: 'EnEmision', width: '125px', title: i18n.t('configurations.en_emision'), columnMenu: 'myTemplate', locked: false, cell: 'checkboxTemplate' },
    { field: 'EnviarAutomaticamente', width: '250px', title: i18n.t('configurations.envia_auto'), columnMenu: 'myTemplate', locked: false, cell: 'checkboxTemplate' },
    { field: 'DetenerEjecucion', width: '300px', title: i18n.t('rules.detener_ejecucion'), columnMenu: 'myTemplate', locked: false, cell: 'checkboxTemplate' },
    { field: 'idEstadoSalida', width: '225px', title: i18n.t('rules.estado_destino'), format: '["TIPOS_ESTADO", "TIPOS_ESTADO_RECEPCION"]', cell: 'enumTemplate', columnMenu: 'myTemplate', locked: false },
    { field: 'codigoPGESalida', width: '250px', title: i18n.t('configurations.cod_pge_salida'), format: '["TIPOS_PGE", "TIPOS_PGE_RECEPCION"]', cell: 'enumTemplate', columnMenu: 'myTemplate', locked: false },
    { field: 'Grupos', width: '440px', title: i18n.t('groups.header'), columnMenu: 'myTemplate', locked: false, cell: 'groupsTemplate', type: 'boolean', sortable: false, groupable: false },
    { field: 'EnUso', width: '125px', title: i18n.t('app.in_use'), columnMenu: 'myTemplate', locked: false, cell: 'checkboxTemplate' },
    { 
      field: 'idCliente', 
      title: i18n.t('clients.id_client'), 
      hidden: true, 
      columnMenu: 'myTemplate', 
      width: '150px', 
      locked: false,
      only: {
        roles: [7, 8, 3],
      }, 
    },
  ] 
}
const mystore = parent({ selectable: true, navigate: false, namespaced: true, getTranslateColumns: getColumns, getTranslateMasterFilters })

export default mystore
